import * as React from "react";
import { GlobalsContext } from "kw/util/Globals";
import { HeadingMedium } from "kanopi-components/typography";
import { KIND } from "baseui/button";
import { navigate } from "@reach/router";
import { PolicyListing } from "kw/policies/components/PolicyListing";
import { PortalRow } from "kanopi-components/PortalRow";
import { useActivePolicies } from "kw/policies/hooks/usePolicies";
import { useStyletron } from "kanopi-components/theme/useStyletron";

export const SelectPolicyPage = () => {
  const { policies: allPolicies, loading: loadingAllPolicies } = useActivePolicies();
  const handleStartClaimCb = React.useCallback((policy: TPolicy) => {
    if (policy?.claimsAllowed) {
      navigate(`/claims/make-a-claim/${policy.id}/intro`);
    } else {
      navigate("/claims/make-a-claim/error");
    }
  }, []);
  const [, theme] = useStyletron();

  return (
    <GlobalsContext.Provider value="claims">
      <PortalRow>
        <HeadingMedium center marginTop={0}>
          Select a policy
        </HeadingMedium>
      </PortalRow>
      <PortalRow>
        <PolicyListing
          policies={allPolicies}
          loading={loadingAllPolicies}
          noContentMessage="No policies to claim on"
          ctaTitle="Select and start claim"
          ctaCallback={handleStartClaimCb}
          ctaKind={KIND.primary}
          cardBackgroundColor={theme.colors.backgroundSecondary}
        />
      </PortalRow>
    </GlobalsContext.Provider>
  );
};
